import { render } from "./BigDiamonds.vue?vue&type=template&id=4c3893c9"
import script from "./BigDiamonds.vue?vue&type=script&lang=js"
export * from "./BigDiamonds.vue?vue&type=script&lang=js"

import "./BigDiamonds.vue?vue&type=style&index=0&id=4c3893c9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__